import { type SingleTeamRankingResponse } from '@on3/api';
import { slugify } from '@on3/ui-lib/utils/slugify';
import Link from 'next/link';

import styles from './SchoolRankings.module.scss';

interface IProps {
  rankings: SingleTeamRankingResponse | null;
}

export const SchoolRankings = ({ rankings }: IProps) => {
  if (!rankings) return null;

  const {
    nationalRank,
    stateRank,
    wins,
    losses,
    sportResponseRecord,
    stateResponseRecord,
    compositeNationalRank,
    compositeStateRank,
  } = rankings;

  const sport = slugify(sportResponseRecord?.name ?? 'football');
  const state = slugify(stateResponseRecord?.name ?? 'national');
  const natlRank =
    (compositeNationalRank || nationalRank)?.toLocaleString() ?? '-';
  const stRank = (compositeStateRank || stateRank)?.toLocaleString() ?? '-';

  return (
    <div className={styles.block}>
      <Link
        className={styles.stat}
        href={`/high-school/rankings/${sport}/national/`}
      >
        <span>National Rank</span>
        <span>{natlRank}</span>
      </Link>
      <Link
        className={styles.stat}
        href={`/high-school/rankings/${sport}/${state}/`}
      >
        <span>State Rank</span>
        <span>{stRank}</span>
      </Link>
      <div className={styles.stat}>
        <span>Record</span>
        <span>{`${wins ?? 0}-${losses ?? 0}`}</span>
      </div>
    </div>
  );
};
